export default [
    {
        path: '/order',
        name: 'order',
        component: () => import('./Order'),
        children: [{
            path: '/order/:active',
            name: 'order.list',
            meta: {
                title: '我的订单',
                keepAlive: true
            },
            component: () => import('./OrderList'),
        }]
    },
    {
        path: '/orderdetail',
        name: 'order.detail',
        meta: {
            title: '订单详情'
        },
        component: () => import('./OrderDetail')
    }
]